import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function analyzeUrl(url) {
  const { data } = await apiClient.post("/analyze", { url });
  return data;
}

export async function startAnalyze(url) {
  const { data } = await apiClient.post("/analyze/start", { url });
  return data;
}

export async function getMatchMirror(reportId) {
  const { data } = await apiClient.get(`/reports/${reportId}/match-mirror`);
  return data;
}

export async function getAnalyzeStatus(jobId) {
  const { data } = await apiClient.get(`/analyze/status/${jobId}`);
  return data;
}

export async function getReport(id) {
  const { data } = await apiClient.get(`/reports/${id}`);
  return data;
}

export async function getRecentReports(limit = 8) {
  const { data } = await apiClient.get(`/reports/recent?limit=${limit}`);
  return data;
}

export async function getMe() {
  const { data } = await apiClient.get("/auth/me");
  return data;
}

export async function postSession(session_id) {
  const { data } = await apiClient.post("/auth/session", { session_id });
  return data;
}

export async function logout() {
  await apiClient.post("/auth/logout");
}

export async function getMyReports() {
  const { data } = await apiClient.get("/my-reports");
  return data;
}

export async function deleteReport(id) {
  await apiClient.delete(`/reports/${id}`);
}

export async function submitFeedback(report_id, play_index, reaction) {
  const { data } = await apiClient.post("/feedback", { report_id, play_index, reaction });
  return data;
}

export async function emailReport(report_id, recipient_email) {
  const { data } = await apiClient.post("/email-report", { report_id, recipient_email });
  return data;
}

export async function rescanReport(report_id) {
  const { data } = await apiClient.post(`/reports/${report_id}/rescan`);
  return data;
}

export async function startRescan(report_id) {
  const { data } = await apiClient.post(`/reports/${report_id}/rescan/start`);
  return data;
}

export async function createPortalSession() {
  const { data } = await apiClient.post("/payments/portal", {
    origin_url: window.location.origin,
  });
  return data;
}

export async function getReportHistory(report_id) {
  const { data } = await apiClient.get(`/reports/${report_id}/history`);
  return data;
}

export async function diffReports(newer_id, prev_report_id) {
  const { data } = await apiClient.post(`/reports/${newer_id}/diff`, { prev_report_id });
  return data;
}

// ============ PAYMENTS ============

export async function getPricing() {
  const { data } = await apiClient.get("/pricing");
  return data.packages;
}

export async function getCredits() {
  const { data } = await apiClient.get("/credits");
  return data;
}

export async function createCheckout(package_id) {
  const origin_url = window.location.origin;
  const { data } = await apiClient.post("/payments/checkout", { package_id, origin_url });
  return data;
}

export async function getPaymentStatus(session_id) {
  const { data } = await apiClient.get(`/payments/status/${session_id}`);
  return data;
}

// ============ WATCHLIST & MONITORING ============

export async function getWatchlist() {
  const { data } = await apiClient.get("/watchlist");
  return data;
}

export async function getWatchStatusForReport(report_id) {
  const { data } = await apiClient.get(`/watchlist/for-report/${report_id}`);
  return data;
}

export async function pauseWatch(watch_id) {
  const { data } = await apiClient.post(`/watchlist/${watch_id}/pause`);
  return data;
}

export async function resumeWatch(watch_id) {
  const { data } = await apiClient.post(`/watchlist/${watch_id}/resume`);
  return data;
}

export async function removeWatch(watch_id) {
  const { data } = await apiClient.delete(`/watchlist/${watch_id}`);
  return data;
}

export async function updateWatch(watch_id, fields) {
  const { data } = await apiClient.patch(`/watchlist/${watch_id}`, fields);
  return data;
}

export async function getAlerts(limit = 20) {
  const { data } = await apiClient.get(`/alerts?limit=${limit}`);
  return data;
}

export async function markAlertRead(alert_id) {
  const { data } = await apiClient.post(`/alerts/${alert_id}/read`);
  return data;
}

export async function markAllAlertsRead() {
  const { data } = await apiClient.post("/alerts/read-all");
  return data;
}
